var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEtrReturnStatusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.414062C10.5894 0.41429 13.499 3.32458 13.499 6.91406C13.4988 10.5033 10.5893 13.4129 7 13.4131C3.41052 13.4131 0.500228 10.5035 0.5 6.91406C0.5 3.32444 3.41038 0.414062 7 0.414062ZM7.53027 3.98828C7.25576 3.71376 6.82094 3.69645 6.52637 3.93652L6.46875 3.98828L4.55273 5.9043C4.25996 6.1972 4.25988 6.67297 4.55273 6.96582C4.82739 7.24022 5.26215 7.25694 5.55664 7.0166L5.61328 6.96582L6.25 6.32812V9.46973C6.25008 9.88384 6.58588 10.2197 7 10.2197C7.41396 10.2195 7.74992 9.88372 7.75 9.46973V6.33008L8.38574 6.96582L8.44238 7.0166C8.73683 7.25703 9.17158 7.24014 9.44629 6.96582C9.7208 6.69131 9.7381 6.25649 9.49805 5.96191L9.44629 5.9043L7.53027 3.98828Z",
    fill: "#7A6007"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtrReturnStatusIcon);
export default __webpack_public_path__ + "static/media/etr-return-status-icon.a3c98c94fa02db283f2456a35fc54ab2.svg";
export { ForwardRef as ReactComponent };